// imports
import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { Box, Flex, TextV2 } from '@withjoy/joykit';

// local imports
import { useTranslation } from '@shared/core';
import { TravelCurrencyCode } from '@graphql/generated';
import { Skeleton } from '@shared/components/Skeleton/Skeleton';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { minorUnitsToCostProperty } from '@apps/stays/components/OfferSummary/utils';
import { useGeoBasedLocale } from '@shared/hooks/useGeoLocale';

// interfaces
interface JoyPricingSectionProps {
  digits?: number;
  joyPrice?: number;
  isPricingLoading: boolean;
  currency?: TravelCurrencyCode;
}

export const JoyPricingSection: React.FC<JoyPricingSectionProps> = React.memo(({ isPricingLoading, joyPrice, currency, digits }) => {
  const { t } = useTranslation('guestSiteCustom');
  const accTrans = t('accommodations');
  const { languageCodeIso15897 } = useGeoBasedLocale();

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
    >
      <JoyLogo
        width={pxToRem(43)}
        height={pxToRem(24)}
      />
      <Flex
        gap={pxToRem(5)}
        alignItems="center"
      >
        <TextV2
          color="mono14"
          fontFamily={'Inter UI'}
          typographyVariant="label2"
        >
          {accTrans.linkInterceptor.guestOnlyPrice()}
        </TextV2>
        <Skeleton
          isReady={!isPricingLoading}
          placeholder={
            <Box
              width={pxToRem(60)}
              height={pxToRem(24)}
              backgroundColor="mono3"
              borderRadius={pxToRem(4)}
            >
              &nbsp;
            </Box>
          }
        >
          <TextV2
            fontWeight={600}
            fontFamily={'Inter UI'}
            typographyVariant="hed5"
          >
            {joyPrice && currency ? minorUnitsToCostProperty({ valueInMinorUnits: joyPrice, currency: currency, digits: digits }, languageCodeIso15897).display : 'N/A'}
          </TextV2>
        </Skeleton>
      </Flex>
    </Flex>
  );
});

JoyPricingSection.displayName = 'JoyPricingSection';
